import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn, staggerContainer, staggerItem } from './ui/FadeIn';
import { Calendar, Brain, RefreshCw, Unlock, Wind, Apple, HeartHandshake, Headphones, Gift } from 'lucide-react';
const inclusions = [{
  icon: <Calendar size={24} data-id="element-1" />,
  title: '30 días de guía diaria',
  description: 'Cada día tiene explicación + parte práctica.'
}, {
  icon: <Brain size={24} data-id="element-2" />,
  title: 'Regulación del sistema nervioso',
  description: 'Por qué reaccionas así — y cómo cambiarlo.'
}, {
  icon: <RefreshCw size={24} data-id="element-3" />,
  title: 'Ruptura de patrones',
  description: 'Los ciclos que te tienen atrapada — identificados y rotos.'
}, {
  icon: <Unlock size={24} data-id="element-4" />,
  title: 'Creencias limitantes',
  description: 'Lo que cargabas desde niña — suelto.'
}, {
  icon: <Wind size={24} data-id="element-5" />,
  title: 'Técnicas de respiración',
  description: 'Para el momento exacto en que todo explota.'
}, {
  icon: <Apple size={24} data-id="element-6" />,
  title: 'Equilibrio del organismo',
  description: 'Alimentación, ejercicio y vitaminas que regulan tu energía.'
}, {
  icon: <HeartHandshake size={24} data-id="element-7" />,
  title: 'Fe aplicada',
  description: 'Soltar el control y confiar — con herramientas reales.'
}];
export function BenefitsSection() {
  return <section className="py-24 bg-cream-alt" data-id="element-8">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-9">
        <FadeIn className="text-center mb-16 max-w-3xl mx-auto" data-id="element-10">
          <p className="text-2xl font-heading text-brown mb-2" data-id="element-11">Por eso creé</p>
          <p className="text-4xl md:text-5xl font-heading font-bold italic text-gold-dark mb-8" data-id="element-12">
            "De Caos a Calma."
          </p>
          <p className="text-2xl font-heading italic text-gold-dark mb-8" data-id="element-13">
            El ebook de 30 días para la mamá que lo hace sola — y quiere hacerlo
            en paz
          </p>
          <p className="text-lg text-brown-light leading-relaxed" data-id="element-14">
            No es un libro de autoayuda genérico. No es una lista de tips de
            Instagram. No es teoría escrita por alguien que no lo vivió.
            <br data-id="element-15" />
            <br data-id="element-16" />
            <strong className="text-brown" data-id="element-17">
              Es mi historia. Mi proceso. Lo que realmente funcionó — adaptado
              para que tú puedas empezar hoy.
            </strong>
          </p>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full opacity-50 mt-12" data-id="element-18" />
        </FadeIn>

        <FadeIn className="text-center mb-12" data-id="element-19">
          <h3 className="text-3xl font-bold text-brown" data-id="element-20">📦 LO QUE INCLUYE</h3>
        </FadeIn>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-21">
          {inclusions.map((item, index) => <motion.div key={index} variants={staggerItem} className={`bg-cream p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-warm-deep/50 ${index === 6 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-22">
              <div className="w-12 h-12 rounded-full bg-sage/10 text-sage flex items-center justify-center mb-6" data-id="element-23">
                {item.icon}
              </div>
              <h3 className="text-xl font-heading font-bold text-gold-dark mb-3" data-id="element-24">
                {item.title}
              </h3>
              <p className="text-brown-light leading-relaxed" data-id="element-25">
                {item.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}